module.exports = __webpack_public_path__ + "static/media/noun_export_2135794.aa59c587.svg";